import React, { forwardRef, type HTMLAttributes } from 'react';
import styles from './SelectQuestion.scss';

type Props = React.DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const SelectQuestionContainer = forwardRef<HTMLDivElement, Props>(
  ({ children, ...otherProps }, ref) => (
    <div className={styles.container} ref={ref} {...otherProps}>
      {children}
    </div>
  )
);
